import { styled } from 'styled-system/jsx'

const FieldContainer = styled('label', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    minWidth: '0',
  },
})

const FieldLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

const FieldInput = styled('input', {
  base: {
    fontFamily: 'body',
    fontSize: '16px',
    padding: '12px 14px',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'sm',
    backgroundColor: '#FFFFFF',
    color: 'quickpass.ink',
    outline: 'none',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _focus: {
      borderColor: 'quickpass.primary',
      boxShadow: '0 0 0 4px rgba(128, 84, 255, 0.12)',
    },
    _placeholder: {
      color: '#B8B0CC',
      opacity: '1',
    },
  },
  variants: {
    hasError: {
      true: {
        borderColor: 'quickpass.warmth',
        _focus: {
          borderColor: 'quickpass.warmth',
          boxShadow: '0 0 0 4px rgba(255, 139, 115, 0.18)',
        },
      },
    },
  },
})

const FieldHelperText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
  variants: {
    isError: {
      true: {
        color: 'quickpass.warmth',
        fontWeight: '600',
      },
    },
  },
})

export { FieldContainer, FieldLabel, FieldInput, FieldHelperText }
